<template>
  <div>
    <o-section :overlay="true">
      <o-select-input label="Aanbieder" initial="nmbs">
        <option value="nmbs">NMBS</option>
        <option value="mobibname">MOBIB (op naam)</option>
        <option value="mobibbasic">MOBIB (basic)</option>
        <option value="tec">TEC</option>
      </o-select-input>
    </o-section>
    <o-section :overlay="true">
      <div class="u-center">
        <p>
          Je vindt het kaartnummer van je MOBIB-kaart linksonder en het
          serienummer rechtsboven.
        </p>
        <p>
          <img
            src="/images/mobib-info.png"
            class="c-card-example"
            width="300"
            alt="MOBIB card"
          />
        </p>
      </div>
    </o-section>
  </div>
</template>

<script>
export default {
  name: 'OMobibInfo'
}
</script>
